import { netvrk } from 'pools/finished/netvrk/netvrk';
import { netvrkLand } from 'pools/finished/netvrk/netvrk-land';
import { netvrkTransport } from 'pools/finished/netvrk/netvrk-transport';

export const netvrkPools = [netvrkLand, netvrk, netvrkTransport];
